import { GET_WALLET_SUMMARY_REQUEST, GET_WALLET_SUMMARY_SUCCESS, GET_WALLET_SUMMARY_FAILURE } from "../ActionTypes/ActionTypes.js";

import api from "../utils/axiosInstance.js";

export const getWalletSummary = (uid, isLoading = true) => async (dispatch) => {
    try {
        if (isLoading) dispatch({ type: GET_WALLET_SUMMARY_REQUEST });
        const response = await api.post("/wallet/getUserwallet", { uid });
        if (response?.data?.success) {
            dispatch({ type: GET_WALLET_SUMMARY_SUCCESS, payload: response.data.result });
        } else {
            dispatch({ type: GET_WALLET_SUMMARY_FAILURE, payload: response.data.message || 'Something went wrong' });
        }
    } catch (error) {
        dispatch({ type: GET_WALLET_SUMMARY_FAILURE, payload: error.message || "Something went wrong" });
    }
};